<template>
  <div style="width: 100%; height: 100%" class="d-flex flex-column">
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center mb-16"
      style="height: 100vh"
    >
      <v-progress-circular
        indeterminate
        color="secondary"
        size="60"
        style="margin-bottom: 200px"
      >
      </v-progress-circular>
    </div>

    <l-map
      ref="map"
      :class="$route.path == '/parking' ? 'map_style_1' : 'map_style'"
      style="width: 100%; z-index: 0"
      :zoom="zoom"
      :center="
        pois.length > 0
          ? [parseFloat(pois[0].latitude), parseFloat(pois[0].longitude)]
          : [39.0742, 21.8243]
      "
      :options="{ zoomControl: false, maxZoom: 18 }"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
        :detectRetina="true"
        :options="{ maxNativeZoom: 18, maxZoom: 18 }"
      ></l-tile-layer>
      <l-control-zoom position="topright"></l-control-zoom>

      <l-control position="topleft" class="d-flex flex-column align-start">
        <div
          v-if="$route.path.split('/')[4] == 'parking'"
          class="primary rounded-pill px-2 d-flex align-center"
          @click="$router.push(`/islands/area/2`)"
        >
          <v-btn icon v-if="$route.path.split('/')[1] != 'pois'">
            <v-icon color="white" size="17">mdi-arrow-left</v-icon>
          </v-btn>
          <span
            v-if="$route.path.split('/')[1] != 'pois'"
            class="body-2 white--text pr-1"
            >{{
              $route.path.split("/")[4] == "map"
                ? currentArea.name
                : $t("pois.title")
            }}</span
          >
        </div>
      </l-control>

      <v-marker-cluster
        :options="{
          disableClusteringAtZoom: 18,
          spiderfyOnMaxZoom: false,
          showCoverageOnHover: false,
          // zoomToBoundsOnClick: false,
        }"
      >
        <div v-for="(poi, i) in pois" :key="i">
          <l-marker
            v-if="poi.category_id != 23"
            @click="openDialog(poi)"
            :lat-lng="[parseFloat(poi.latitude), parseFloat(poi.longitude)]"
            :draggable="false"
            :zIndexOffset="-1"
          >
          </l-marker>
          <l-marker
            v-if="poi.category_id == 23 && poi.id != 334"
            @click="openGoogleMaps(poi)"
            :lat-lng="[parseFloat(poi.latitude), parseFloat(poi.longitude)]"
            :draggable="false"
            :zIndexOffset="-1"
          >
            <l-icon
              :icon-size="[41, 41]"
              icon-url="/parking-pin.svg"
              className="filter-blue"
            >
            </l-icon>
          </l-marker>
          <l-marker
            v-if="poi.has_bus || poi.id == 334"
            :lat-lng="getBusMarkerPosition(poi)"
            :draggable="false"
            :zIndexOffset="1"
          >
            <l-icon :icon-size="[41, 41]" icon-url="/bus-pin.svg"> </l-icon>
            <l-popup v-if="busScheduleText(poi)">
              {{ busScheduleText(poi) }}
            </l-popup>
          </l-marker>
        </div>
      </v-marker-cluster>

      <custom-marker
        :marker="{ lat: location.latitude, lng: location.longitude }"
      >
        <v-icon color="secondary" class="rounded-circle pulse-button" size="15"
          >mdi-circle</v-icon
        >
      </custom-marker>

      <l-control position="bottomright">
        <div class="d-flex flex-column align-center mt-2">
          <v-btn
            icon
            class="primary mb-2 white--text"
            @click="getLocation(true)"
            :loading="locationLoader"
          >
            <v-icon color="white">mdi-crosshairs-gps</v-icon>
          </v-btn>
        </div>
      </l-control>
    </l-map>

    <v-dialog
      persistent
      v-model="dialog.open"
      max-width="100%"
      fullscreen
      style="z-index: 900 !important"
      no-click-animation
    >
      <PoiDialog :poi="dialog.poi" v-if="dialog.open" @close="closeDialog" />
    </v-dialog>
  </div>
</template>

<script>
import PoiDialog from "@/components/PoiDialog.vue";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import axios from "axios";
import CustomMarker from "vue-leaflet-custom-marker";
import L from "leaflet";

import {
  LMap,
  LTileLayer,
  LMarker,
  LControl,
  LControlZoom,
  LIcon,
  LPopup,
} from "vue2-leaflet";

import { Icon } from "leaflet";

import { mapActions, mapState } from "vuex";

// Icon fix
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  components: {
    PoiDialog,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LControlZoom,
    LIcon,
    LPopup,
    CustomMarker,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
  },

  async created() {
    try {
      const pois = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/areas/2/subarea/pois`
      );

      this.pois = pois.data.filter((el) => el.category_id == 23);
      // 23
      this.loader = false;
      await this.getLocation(false);
      // var markers = L.markerClusterGroup({
      //   disableClusteringAtZoom: 18,
      //   spiderfyOnMaxZoom: false,
      //   showCoverageOnHover: false,
      //   // zoomToBoundsOnClick: false,
      // });
      // for (let i = 0; i < this.pois.length; i++) {
      //   markers.addLayer(
      //     L.marker([this.pois[i].latitude, this.pois[i].longitude])
      //   );
      //   this.map.addLayer(markers);
      // }
      this.loader = false;
    } catch (e) {
      console.log(e);
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.map?.mapObject;

      // setTimeout(() => {
      //   this.$refs?.startPageHeight.scrollIntoView();
      // }, 2000);
    });
  },

  data() {
    return {
      locationLoader: false,
      sheet: false,
      subareas: [],
      subarea: null,
      pois: [],
      step: 2,
      map: null,

      loader: true,

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 9,

      dialog: {
        open: false,
        poi: null,
      },
    };
  },

  computed: {
    ...mapState({
      currentArea: (state) => state.areas.currentArea,
      location: (state) => state.base.location,
    }),
  },

  methods: {
    ...mapActions(["getLocation"]),
    openGoogleMaps(poi) {
      window.open(
        `https://www.google.com/maps/dir/?api=1&origin=${this.location.latitude}, ${this.location.longitude}&destination=${poi.latitude}, ${poi.longitude}&travelmode=driving`
      );
    },

    getBusMarkerPosition(poi) {
      const latitude = parseFloat(poi.latitude);
      const longitude = parseFloat(poi.longitude);

      // Small offset so bus marker appears next to the parking marker.
      return [latitude, longitude + 0.00012];
    },

    busScheduleText(poi) {
      return poi.bus_schedule || poi.bus_Schedule || "";
    },

    async getLocation(setView) {
      try {
        this.locationLoader = true;
        await this.$store.dispatch("getLocation");
        this.locationLoader = false;
        if (setView) this.setView(this.location);
      } catch (e) {
        console.log(e);
      }
    },

    setView(coords) {
      this.$refs.map.mapObject.setView(
        [coords.latitude, coords.longitude],
        16,
        {
          // animate: true,
          // duration: 1,
        }
      );
    },

    subareaCategory(subarea) {
      return this.subareas.find((el) => el.id == subarea.id);
    },

    async onSubareaSelect(subarea) {
      this.loader = true;
      this.sheet = false;

      if (subarea == undefined) {
        const pois = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subarea/pois`
        );

        this.pois = pois.data;
        this.subarea = subarea;
        this.loader = false;
        return;
      }
      const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
        params: {
          area: subarea.id,
        },
      });
      this.pois = res.data;
      this.subarea = subarea;
      this.loader = false;
    },

    openDialog(poi) {
      this.dialog = {
        open: true,
        poi,
      };
    },

    closeDialog() {
      this.dialog = {
        open: false,
        poi: null,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.map_style {
  height: calc(100vh - 154px);
}

.map_style_1 {
  height: calc(100vh - 98px);
}

.pulse-button {
  -webkit-animation: pulse-location 1.5s infinite;
  box-shadow: 0 0 0 8px rgba(#5a99d4, 0.5);
  border: 0.5px solid white;
}

.pulse-button:hover {
  -webkit-animation: none;
}

.check-icon {
  width: 19px;
  height: 14px;
}

.filter-blue {
  filter: invert(44%) sepia(36%) saturate(1166%) hue-rotate(167deg)
    brightness(96%) contrast(87%);
}
</style>
